import script from "./AppVoiceToText.vue?vue&type=script&setup=true&lang=js"
export * from "./AppVoiceToText.vue?vue&type=script&setup=true&lang=js"

import "./AppVoiceToText.vue?vue&type=style&index=0&id=76af12b9&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76af12b9"]])

export default __exports__